var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/elements/spire_mid_level_test/template.jade");
module.exports = (req['default'] || req).apply(req, [])